import { createSlice } from "@reduxjs/toolkit";

const TOGGLE_STORAGE_KEY = 'manualModeToggle';

// Load initial state from localStorage
const loadToggleState = () => {
  try {
    const savedState = localStorage.getItem(TOGGLE_STORAGE_KEY);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      return {
        isToggled: parsedState.isToggled || false,
        showAllResults: parsedState.showAllResults || false,
        showMyManuals: parsedState.showMyManuals !== undefined ? parsedState.showMyManuals : true,
      };
    }
  } catch (error) {
    console.error('Error loading toggle state from localStorage:', error);
  }
  
  // Return default state if no saved state or error
  return {
    isToggled: false,
    showAllResults: false,
    showMyManuals: true,
  };
};

// Save state to localStorage
const saveToggleState = (state) => {
  try {
    const stateToSave = {
      isToggled: state.isToggled,
      showAllResults: state.showAllResults,
      showMyManuals: state.showMyManuals,
    };
    localStorage.setItem(TOGGLE_STORAGE_KEY, JSON.stringify(stateToSave));
  } catch (error) {
    console.error('Error saving toggle state to localStorage:', error);
  }
};
// Force initial state to false on app startup
const getInitialState = () => {
  // Clear any existing localStorage state on app initialization
  // This ensures we always start in normal mode
  const defaultState = {
    isToggled: false,
    showAllResults: false,
    showMyManuals: true,
  };
  
  // Only load from localStorage if we're in a search context
  // For now, always start with default state
  return defaultState;
};
const initialState = getInitialState();

export const toggleManualsSlice = createSlice({
  name: "toggleManuals",
  initialState,
  reducers: {
    setToggleManuals: (state, action) => {
      state.isToggled = action.payload;
      state.showAllResults = action.payload;
      state.showMyManuals = !action.payload;
      saveToggleState(state);
    },
    toggleManualsOn: (state) => {
      state.isToggled = true;
      state.showAllResults = true;
      state.showMyManuals = false;
      saveToggleState(state);
    },
    toggleManualsOff: (state) => {
      state.isToggled = false;
      state.showAllResults = false;
      state.showMyManuals = true;
      saveToggleState(state);
    },
    resetToggleManuals: (state) => {
      state.isToggled = false;
      state.showAllResults = false;
      state.showMyManuals = true;
      // saveToggleState(state);
      // Clear localStorage when resetting
      localStorage.removeItem(TOGGLE_STORAGE_KEY);
    },
    // Add new action to load state from localStorage (for specific use cases)
    loadToggleFromStorage: (state) => {
      const savedState = loadToggleState();
      state.isToggled = savedState.isToggled;
      state.showAllResults = savedState.showAllResults;
      state.showMyManuals = savedState.showMyManuals;
    },
  },
});

export const { 
  setToggleManuals, 
  toggleManualsOn, 
  toggleManualsOff, 
  resetToggleManuals 
} = toggleManualsSlice.actions;

export default toggleManualsSlice;